import { useApp } from 'contexts/app';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Stack, Text } from 'shell/components';

const FormativeFeedback = () => {
    const { currentAssignmentId } = useApp();
    const { t } = useTranslation('assignment');
    const history = useHistory();

    const handleClick = () => {
        const params = new URLSearchParams({ type: 'formative' });
        history.push(`/assignments/${currentAssignmentId}/submissions?${params.toString()}`);
    };

    return (
        <Stack alignItems={'flex-start'} spacing={2}>
            <Text variant={'sh2'} weight={'semibold'}>
                {t('formative-feedback.student-insights', 'Formative Feedback for Student Insights')}
            </Text>
            <Text color={'light'}>
                {t(
                    'formative-feedback.student-insights-description',
                    'See how students refine their drafts and how the AI you’ve trained helps them improve their assignments.'
                )}
            </Text>
            <Button variant={'borderless'} onClick={handleClick}>
                {t('formative-feedback.view-insights', 'View Insights')}
            </Button>
        </Stack>
    );
};

export default FormativeFeedback;
